import styled from 'styled-components';
import theme from 'v3/theme';

const MarkerContainer = styled.div`
  position: relative;
  background-color: ${({ background }) => theme.colors[background] || background};
  padding: 5px 22px 5px 10px;
  min-width: 150px;
  border-radius: 5px;

  .marker-map-close {
    position: absolute;
    top: 4px;
    right: 6px;
    border: 0;
    background: transparent;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    padding: 2px;
  }

  &:after {
    content: '';
    position: absolute;
    top: 14px;
    left: -10px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid ${({ background }) => theme.colors[background] || background};
  }
`;

export default MarkerContainer;
